/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "8fd32264f22d6713f449bd09fe534b6204503ceb";
